module.exports = __webpack_public_path__ + "47ba7bc299e76e5891fe6b6185dbefc2.pdf";